module.exports = __webpack_public_path__ + "img/help_rentmech.1ee9024e.svg";